import { ADD_TO_FAVORITES, REMOVE_FROM_FAVORITES, CLEAR_FAVORITES } from '../actions/favoritesActions';

const initialState = {
  items: [],
};

const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_FAVORITES:
      // Check if the item already exists in favorites
      if (state.items.some(item => item.id === action.payload.id)) {
        return state; // If it exists, don't add it again
      }
      return {
        ...state,
        items: [...state.items, action.payload], // Add new item
      };

    case REMOVE_FROM_FAVORITES:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload), // Remove item
      };

    case CLEAR_FAVORITES:
      return {
        ...state,
        items: [], // Clear all favorites
      };

    default:
      return state; // Ensure you return the state for unknown actions
  }
};

export default favoritesReducer;
